<template>
  <BreadCrumb>
    <BreadCrumbItem to="/">
      Home
    </BreadCrumbItem>
    <BreadCrumbItem
      @click="clickAllCategories"
      clickable
    >
      All Categories
    </BreadCrumbItem>
    <BreadCrumbItem
      v-if="parentParentCategoryName"
      @click="clickParentParentCategory"
      clickable
    >
      {{ parentParentCategoryName }}
    </BreadCrumbItem>
    <BreadCrumbItem
      v-if="parentCategoryName"
      @click="clickParentCategory"
      clickable
    >
      {{ parentCategoryName }}
    </BreadCrumbItem>
    <BreadCrumbItem v-if="categoryName && categoryName !== 'null'">
      {{ categoryName }}
    </BreadCrumbItem>
  </BreadCrumb>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { openURLWithChannelQuery } from '@/utils/utils'
import { BreadCrumb, BreadCrumbItem } from '@/components/BreadCrumb'
const store = useStore()
const route = useRoute()
defineProps({
  categoryName: String
})

const parentParentCategoryName = computed(() => route.query.ppName)
const parentCategoryName = computed(() => route.query.pName)

// 点击All Categories 展示类目筛选
const clickAllCategories = () => {
  store.commit('common/SET_CATEGORY_VISIBLE', true)
}
// 点击 一级, 展示类目筛选优先选中一级
const clickParentParentCategory = () => {
  store.commit('common/SET_CATEGORY_VISIBLE', true)
}
// 点击二级跳转页面
const clickParentCategory = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const categoryId = searchParams.get('pId')
  const categoryName = searchParams.get('pName')
  const ppName = searchParams.get('ppName')
  const ppId = searchParams.get('ppId')
  const keyword = searchParams.get('keyword') || ''
  openURLWithChannelQuery(`/search?categoryId=${categoryId}&categoryName=${categoryName}&ppId=${ppId}&ppName=${ppName}&keyword=${keyword}`)
}
</script>
<style scoped lang="less">
</style>
